const required = ['VITE_API_BASE_URL'] as const;
type Required = (typeof required)[number];

function read(): Record<Required, string> {
  const out: Partial<Record<Required, string>> = {};
  for (const k of required) {
    const v = (import.meta.env as Record<string, string | undefined>)[k];
    if (!v) throw new Error(`missing env ${k}`);
    out[k] = String(v);
  }
  return out as Record<Required, string>;
}

export const env = read();
